export enum CampaignRejectionReasonsColumns {
  reason = 'reason',
  messages = 'messages'
}
